import  { useState, useEffect } from 'react';
import { PolarArea } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import config from "../config.js";


ChartJS.register(
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
);

const AnalyticsSeasions = ({ data = [] }) => {
  const [GoogleData, setGoogleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;
  
  useEffect(() => {
    
    if (data && data.length > 0) {
      setGoogleData(data);
      setLoading(false);
      return;
    }

   
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/MarketingworkbookToJson`);
        
        const googleData = response.data.data?.Google || [];
        setGoogleData(googleData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL, data]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography variant="h6" color="error">Error fetching data</Typography>;
  }

 
  if (!GoogleData || GoogleData.length === 0) {
    return <Typography variant="h6">No data available</Typography>;
  }

 
  const totalDirect = GoogleData.reduce((acc, entry) => acc + (entry.DIRECT || 0), 0);
  const totalOrganic = GoogleData.reduce((acc, entry) => acc + (entry.ORGANIC || 0), 0);
  const totalReferral = GoogleData.reduce((acc, entry) => acc + (entry.REFERRAL || 0), 0);
  const totalPaid = GoogleData.reduce((acc, entry) => acc + (entry.PAID || 0), 0);
  const totalOther = GoogleData.reduce((acc, entry) => acc + (entry.OTHER || 0), 0);

  const chartData = {
    labels: ['Direct', 'Organic', 'Referral', 'Paid', 'Other'],
    datasets: [
      {
        data: [totalDirect, totalOrganic, totalReferral, totalPaid, totalOther],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      r: {
        ticks: {
          backdropColor: 'rgba(0, 0, 0, 0)',
          color: 'white',
        },
      },
    },
  };

  return (
    <Box>
      <PolarArea data={chartData} options={options} />
    </Box>
  );
};

export default AnalyticsSeasions;
